import { Directive, Input } from '@angular/core';

type Placement = 'page-actions';

@Directive({
  selector: '[crmTableContent]',

})
export class ListObjectsTableContentDirective {
  @Input() set crmTableContent(value: Placement) {
    this.placement = value;
  }
  placement?: Placement;
}
